import React from "react";
import { SvgIcon } from "@mui/material";

export default function DuplicateIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="5" y="5" width="12" height="12" rx="2" ry="2" fill="none" opacity="0.4" />
        <rect x="7" y="7" width="12" height="12" rx="2" ry="2" fill="none" opacity="0.8" />
      </g>
    </SvgIcon>
  );
}
